<mat-card>
  <app-card-header
    [title]="title"
    [subtitle]="subtitle"
    icono="lightbulb"
    [draggable]="false"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- Content -->
      <mat-card-content
        [class.cardContentFullscreen]="!subtitle"
        [class.cardContentFullscreenSubtitle]="subtitle"
        class="card-content-crear"
      >
        <!-- Datos Básicos -->
        <app-content-card title="Datos de la Luminaria" icon="lightbulb">
          <!-- Identificación -->
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Identificación</mat-label>
              <input matInput formControlName="identificacion" />
              <mat-icon matPrefix>badge</mat-icon>
            </mat-form-field>

            <!-- Cliente y Grupos -->
            @if (mostrarCamposCliente && !id) {
              <div style="width: 100%; display: flex; gap: 8px">
                <app-cliente-selector
                  formControlName="idCliente"
                  style="flex: 1"
                  (clienteChange)="onClienteChange()"
                  [filterModules]="['moduloLuminarias']"
                  [showCrearBtn]="
                    helper.tienePermiso('Administración - Crear clientes')
                  "
                ></app-cliente-selector>
              </div>
            }
          </section>

          <!-- Cinco campos en una fila no entraban: los textos pisaban la
               flecha de los selectores. Grupos, puesta y ST van abajo. -->
          <section class="inputs-group">
            <!-- Grupos -->
            <app-grupo-selector
              [idCliente]="form?.get('idCliente')?.value"
              categoria="Luminaria"
              formControlName="idsGrupos"
              [multiple]="true"
              [showCrearBtn]="
                helper.tienePermiso('Luminarias - Crear agrupaciones')
              "
              (gruposChange)="onGruposChange($event)"
            ></app-grupo-selector>

            <!-- Puesta (clientes con moduloLuminarias.usaPuestas): la luminaria
                 toma su ubicación de la puesta -->
            @if (usaPuestas) {
              <div
                style="
                  display: flex;
                  gap: 5px;
                  align-items: center;
                  width: 100%;
                "
              >
                <ng-select
                  class="custom-ng-select"
                  [items]="puestas"
                  bindLabel="identificacion"
                  bindValue="_id"
                  formControlName="idPuesta"
                  placeholder="Puesta"
                  [notFoundText]="'No hay puestas disponibles'"
                  (change)="onPuestaChange($event?._id)"
                  searchable="true"
                  appendTo="body"
                  style="flex: 1"
                ></ng-select>
                @if (helper.tienePermiso('Luminarias - Crear puestas')) {
                  <app-button
                    matType="mat-fab"
                    color="primary"
                    icon="add"
                    matTooltip="Crear puesta"
                    (click)="crearPuesta()"
                  ></app-button>
                }
              </div>
            }

            <!-- Puede recibir servicio técnico -->
            <div class="st-checkbox-field">
              <app-checkbox
                title="¿Puede recibir servicio técnico?"
                formControlName="puedeSolicitarServicioTecnico"
                margin="0 16px"
              ></app-checkbox>
            </div>
          </section>
        </app-content-card>

        <!-- Dispositivo y Modelo -->
        <app-content-card title="Dispositivo y Modelo" icon="devices">
          <!-- Dispositivo Lorawan -->
          <section class="inputs-group">
            <div style="width: 100%">
              <ng-select
                [fixedPlaceholder]="true"
                style="width: 100%"
                [items]="dispositivosLorawan"
                bindLabel="name"
                bindValue="deveui"
                formControlName="deveui"
                placeholder="Dispositivo Lorawan"
                [notFoundText]="'No hay dispositivos Lorawan disponibles'"
                multiple="false"
                searchable="true"
                appendTo="body"
              ></ng-select>

              <!-- Mensajes de estado del dispositivo -->
              @if (
                luminariaConflicto && deveuiVerificado && form?.value?.deveui
              ) {
                <div class="device-status warning">
                  <mat-icon>warning</mat-icon>
                  <span>
                    Ya existe una luminaria "{{
                      luminariaConflicto.identificacion
                    }}" con este dispositivo asignado. Será reemplazado al
                    guardar.
                  </span>
                </div>
              }

              @if (
                !luminariaConflicto && deveuiVerificado && form?.value?.deveui
              ) {
                <div class="device-status success">
                  <mat-icon>check_circle</mat-icon>
                  <span>Dispositivo disponible</span>
                </div>
              }

              @if (!form?.value?.deveui) {
                <div class="device-status info">
                  <mat-icon>info</mat-icon>
                  <span>Sin dispositivo</span>
                </div>
              }

              @if (verificandoDeveui && form?.value?.deveui) {
                <div class="device-status loading">
                  <mat-icon>hourglass_top</mat-icon>
                  <span>Verificando disponibilidad...</span>
                </div>
              }
            </div>

            <!-- Modelo de Luminaria -->
            <app-modelo-dispositivo-selector
              formControlName="idModeloDispositivo"
              [tipo]="'Luminaria'"
              [showCrearBtn]="
                helper.tienePermiso(
                  'Configuraciones - Crear modelos luminarias'
                )
              "
            ></app-modelo-dispositivo-selector>
          </section>
        </app-content-card>

        <!-- Perfil de Configuración -->
        <app-content-card title="Perfil de Configuración" icon="settings">
          <section class="inputs-group">
            <div style="width: 100%">
              <label class="field-label">
                Perfil de configuración (Opcional)
              </label>
              <div style="display: flex; gap: 8px; align-items: center">
                <ng-select
                  [fixedPlaceholder]="true"
                  style="flex: 1"
                  [items]="perfilesConfigFiltrados"
                  bindLabel="nombre"
                  bindValue="_id"
                  formControlName="idPerfilConfig"
                  [placeholder]="
                    form?.get('deveui')?.value
                      ? 'Seleccioná un perfil'
                      : 'Seleccioná un dispositivo primero'
                  "
                  [notFoundText]="
                    'No hay perfiles disponibles para este dispositivo'
                  "
                  multiple="false"
                  searchable="true"
                  appendTo="body"
                  [clearable]="true"
                >
                  <ng-template ng-option-tmp let-item="item">
                    <div class="perfil-option">
                      <span class="perfil-name">{{ item.nombre }}</span>
                      <small class="perfil-details">
                        Tipo: {{ item.tipoConfig || 'Sin tipo' }}
                      </small>
                    </div>
                  </ng-template>
                </ng-select>
                @if (helper.tienePermiso('Luminarias - Editar')) {
                  <app-button
                    matType="mat-fab"
                    color="primary"
                    icon="add"
                    matTooltip="Crear perfil"
                    [disabled]="!form?.get('deveui')?.value"
                    (click)="crearPerfil()"
                  ></app-button>
                }
              </div>
              <app-info-banner
                color="blue"
                icon="info"
                title="¿Qué hace el perfil de configuración?"
                message="El <b>perfil</b> define la <b>configuración deseada</b> de la luminaria. El sistema enviará automáticamente los comandos necesarios para que esta se vea reflejada en la configuración real del dispositivo."
                [closable]="false"
                margin="12px 0 0 0"
              ></app-info-banner>
            </div>
          </section>
        </app-content-card>

        <!-- Ubicación -->
        <app-content-card title="Ubicación" icon="location_on">
          <div class="mapa-embebido-wrapper">
            <app-mapa-ubicar
              [raster]="'google'"
              [form]="geojson"
              [sinValorPorDefecto]="true"
              [centrarA]="centrarA"
              [enableAutocomplete]="true"
              [precision]="9"
              (direccion)="patchDireccion($event)"
            ></app-mapa-ubicar>
          </div>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="this.close()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
